/* Keep the reading position when switching between sibling product pages.

   Each model in these ranges is a separate product, so picking a different
   size is a full page load, and the browser drops you at the top. That reads
   as "the page reset" rather than "the selection changed". Instead we record
   where the selector sat on screen, then put it back in the same place on the
   next page - so the row of buttons stays put and only the content around it
   changes.

   Anchoring on the selector's own offset rather than raw scrollY matters:
   the pages differ in height above the buy box, so the same scrollY would
   land somewhere different on each product. */
(function () {
  var KEY = 'ampd:model-links-offset';
  var SEL = '.model-links';
  var MAX_AGE = 15000; // only restore for a click we just made, not a stale tab

  function selector() {
    return document.querySelector(SEL);
  }

  /* --- carry the chosen options (colour) to the next model ---
     Only for ranges without a Frame selector. The Ace templates deliberately
     hide colour until a frame is picked, and auto-selecting there would undo
     that flow - so the presence of a frame selector is the switch. */
  var OPT_KEY = 'ampd:model-links-options';

  function hasFrameSelector() {
    return !!document.querySelector('.option-selector--frame');
  }

  function chosenOptions() {
    var out = {};
    document.querySelectorAll('variant-picker .option-selector:not(.option-selector--frame)').forEach(function (fs) {
      var name = fs.getAttribute('data-option');
      var on = fs.querySelector('.opt-btn:checked');
      if (name && on) out[name] = on.value;
    });
    return out;
  }

  function applyOptions() {
    if (hasFrameSelector()) return;
    var raw = null;
    try { raw = sessionStorage.getItem(OPT_KEY); if (raw) sessionStorage.removeItem(OPT_KEY); } catch (err) { return; }
    if (!raw) return;
    var data;
    try { data = JSON.parse(raw); } catch (err) { return; }
    if (!data || !data.opts || Date.now() - data.t > MAX_AGE) return;

    // The theme's picker finishes initialising a moment after it's defined and
    // re-asserts the server-rendered selection when it does, which can undo a
    // click made too early. So: apply, check it stuck, and re-apply a few
    // times over the first second if it didn't.
    var attempts = 0;
    function pass() {
      var allGood = true;
      Object.keys(data.opts).forEach(function (name) {
        var fs = document.querySelector('variant-picker .option-selector[data-option="' + name.replace(/"/g, '\\"') + '"]');
        if (!fs) return;
        var match = null;
        fs.querySelectorAll('.opt-btn').forEach(function (r) {
          if (!match && r.value === data.opts[name] && !r.classList.contains('is-unavailable')) match = r;
        });
        // No match (e.g. the new model isn't sold in that colour): leave the
        // page's default selection in place.
        if (!match) return;
        if (!match.checked) { match.click(); allGood = false; }
      });
      attempts += 1;
      if (!allGood || attempts < 3) {
        if (attempts < 6) setTimeout(pass, 250);
      }
    }
    pass();
  }

  /* --- remember, on the way out --- */
  document.addEventListener('click', function (e) {
    var link = e.target && e.target.closest ? e.target.closest('.model-links__item[href]') : null;
    if (!link) return;
    var el = selector();
    if (!el) return;
    try {
      sessionStorage.setItem(KEY, JSON.stringify({
        offset: Math.round(el.getBoundingClientRect().top),
        t: Date.now()
      }));
      if (!hasFrameSelector()) {
        sessionStorage.setItem(OPT_KEY, JSON.stringify({ opts: chosenOptions(), t: Date.now() }));
      }
    } catch (err) {
      /* private mode / storage disabled: fall back to a normal top-of-page load */
    }
  });

  /* --- restore, on the way in --- */
  function restore() {
    var raw = null;
    try {
      raw = sessionStorage.getItem(KEY);
      if (raw) sessionStorage.removeItem(KEY);
    } catch (err) {
      return;
    }
    if (!raw) return;

    var data;
    try { data = JSON.parse(raw); } catch (err) { return; }
    if (!data || typeof data.offset !== 'number') return;
    if (Date.now() - data.t > MAX_AGE) return;

    var docEl = document.documentElement;
    var prevBehavior = docEl.style.scrollBehavior;
    docEl.style.scrollBehavior = 'auto'; // never animate; this should look instant

    function apply() {
      var el = selector();
      if (!el) return;
      var target = el.getBoundingClientRect().top + window.pageYOffset - data.offset;
      window.scrollTo(0, target > 0 ? target : 0);
    }

    // Media above the buy box loads late and shifts everything down, so the
    // position is re-applied as those settle rather than set once.
    apply();
    requestAnimationFrame(apply);
    window.addEventListener('load', function () {
      apply();
      requestAnimationFrame(function () {
        apply();
        docEl.style.scrollBehavior = prevBehavior;
      });
    }, { once: true });
  }

  function boot() {
    restore();
    // The variant picker upgrades itself as a custom element; give it a beat
    // so clicking a swatch is handled by the theme, not just the raw radio.
    if (window.customElements && customElements.whenDefined) {
      customElements.whenDefined('variant-picker').then(applyOptions, applyOptions);
    } else {
      setTimeout(applyOptions, 50);
    }
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
